// extracted by mini-css-extract-plugin
export default {"Logo":"HeaderLogo_Logo__QLTCe"};